module.exports = __webpack_public_path__ + "img/coin_front.437d5009.png";